/**
 * @desc 确认退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/asRefundOrder/complete`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
